import React from 'react'
import { useSelector } from 'react-redux'
import { ButtonBookmarkIcon } from '../../../components'
import { useViewport } from '../../../utils'
import { excerptTrimmer } from '../../../utils/excerpt-trimmer'

const MAX_TITLE_LENGTH = 90
const THUMBNAIL_HEIGHT = '120px'
const THUMBNAIL_HEIGHT_MOBILE = '76px'

const Card = ({data, bookmark}) => {
  const {
    thumbnail,
    date,
    organization,
    title,
  } = data

  const { isMobile } = useViewport()
  const boxShadow = isMobile ? '0px 4px 10px rgba(0, 0, 0, 0.05)' : '0px 4px 20px rgba(0, 0, 0, 0.05)'
  const language = useSelector(state => state.system.language)

  const titleRendered = typeof title === 'string' ? title : (title && title[language.name] ? title[language.name] : JSON.stringify(title) )
  const titleTrimmed = excerptTrimmer(titleRendered, MAX_TITLE_LENGTH)

  return (
    <div
      className="bg-white rounded p-3 lg:p-5 h-full"
      style={{boxShadow: boxShadow}}
      title={titleRendered}
    >
      <div
        className="w-full bg-no-repeat bg-cover bg-center mb-3 lg:mb-4 rounded p-2 shadow"
        style={{backgroundImage: `url('${thumbnail}')`, height: isMobile ? THUMBNAIL_HEIGHT_MOBILE : THUMBNAIL_HEIGHT}}
      >
      {
        bookmark &&
        <ButtonBookmarkIcon className="ml-auto bg-white"/>
      }
      </div>
      <p className="text-gray-999 text-xs mb-2">{organization} /<br/>{date}</p>
      <h3 className="lg:text-lg font-bold lg:mb-2 font-primary">{titleTrimmed}</h3>
    </div>
  )
}

export { Card }
